import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import OlvidePassword from './pages/OlvidePassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Historial from './pages/Historial';
import KPIs from './pages/KPIs';
import Cuentas from './pages/Cuentas';
import CalendarioTributario from './pages/CalendarioTributario';
import RetencionFuente from './pages/RetencionFuente';
import Suscripcion from './pages/Suscripcion';
import Landing from './pages/Landing';
import Contacto from './pages/Contacto';
import Terminos from './pages/legal/Terminos';
import Privacidad from './pages/legal/Privacidad';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  // Ojo: NO gatear en `susLoading` aquí. `susLoading` se vuelve a poner en
  // true cada vez que algo llama a `cargarSuscripcion()` (Admin.js,
  // Suscripcion.js) para refrescar el dato en segundo plano; si esta ruta
  // se desmonta/remonta en respuesta a eso, y la página remontada vuelve a
  // llamar `cargarSuscripcion()` en su propio efecto de montaje, se entra en
  // un loop infinito de desmontar→remontar→refrescar→desmontar... (visto
  // como parpadeo/temblor y peticiones sin parar a /admin/usuarios,
  // /historial y /mi-suscripcion). La suscripción no se exige para entrar
  // (se exige solo al conciliar, ver Dashboard.js / 402), así que basta con
  // esperar la autenticación inicial.
  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#888' }}>
        Cargando...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;

  return children;
}

// "/" muestra el landing público a visitantes sin sesión, y el Dashboard
// a usuarios ya autenticados. Así el resto de la app (que enlaza a "/"
// esperando el Dashboard) sigue funcionando igual para usuarios logueados.
function Root() {
  const { user, loading } = useAuth();

  // Ver el comentario en PrivateRoute: no gatear en `susLoading`.
  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#888' }}>
        Cargando...
      </div>
    );
  }

  return user ? <Dashboard /> : <Landing />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/olvide-password" element={<OlvidePassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/" element={<Root />} />
          <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
          <Route path="/historial" element={<PrivateRoute><Historial /></PrivateRoute>} />
          <Route path="/kpis" element={<PrivateRoute><KPIs /></PrivateRoute>} />
          <Route path="/cuentas" element={<PrivateRoute><Cuentas /></PrivateRoute>} />
          <Route path="/calendario-tributario" element={<PrivateRoute><CalendarioTributario /></PrivateRoute>} />
          <Route path="/retencion-fuente" element={<PrivateRoute><RetencionFuente /></PrivateRoute>} />
          <Route path="/suscripcion" element={<PrivateRoute><Suscripcion /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
